var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ColumnEditModal",
    _vm._b(
      {
        attrs: {
          value: _vm.value,
          configName: _vm.configName,
          columnId: _vm.columnId,
          editMode: _vm.editMode,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "edit-modal-additions",
            fn: function (props) {
              return [
                _c(
                  "v-flex",
                  { attrs: { "pa-2": "" } },
                  [
                    _c(
                      "v-layout",
                      {
                        staticClass: "grey lighten-2",
                        attrs: {
                          "data-ui-component": "analyte-name-sandbox",
                          wrap: "",
                        },
                      },
                      [
                        _c(
                          "v-card-text",
                          {
                            staticClass: "subheading pb-2",
                            staticStyle: { "font-weight": "bold" },
                          },
                          [_vm._v("Try it yourself")]
                        ),
                        _vm._v(" "),
                        _c("AnalyteNameSandbox"),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { "pa-4": "", wrap: "" } },
                  [
                    _c("h3", [
                      _vm._v(
                        " Create a new Analyte with the Analyte name shown above during Import "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-radio-group",
                      {
                        attrs: {
                          column: "",
                          value: _vm.getShouldCreateNewAnalyteValue(
                            props.columnConfiguration
                          ),
                        },
                        on: {
                          change: function ($event) {
                            _vm.callSetColumnMetadata(
                              _vm.shouldCreateNewAnalyteKey,
                              !_vm.getShouldCreateNewAnalyteValue(
                                props.columnConfiguration
                              )
                            )
                          },
                        },
                      },
                      [
                        _c("v-radio", {
                          staticClass: "radio-opts",
                          attrs: {
                            label:
                              "Allow Analytes to be created in Envirodata when an Analyte does not exist during an import",
                            value: true,
                          },
                        }),
                        _vm._v(" "),
                        _c("v-radio", {
                          staticClass: "radio-opts",
                          attrs: {
                            label:
                              "Do not allow Analytes to be created and mark the import as unsuccessful when an Analyte does not exist during the import",
                            value: false,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("h3", [
                      _vm._v(" Delete empty Analytes during rollback "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-radio-group",
                      {
                        attrs: {
                          column: "",
                          value: _vm.getShouldDeleteDuringRollbackValue(
                            props.columnConfiguration
                          ),
                        },
                        on: {
                          change: function ($event) {
                            _vm.callSetColumnMetadata(
                              _vm.shouldDeleteDuringRollbackKey,
                              !_vm.getShouldDeleteDuringRollbackValue(
                                props.columnConfiguration
                              )
                            )
                          },
                        },
                      },
                      [
                        _c("v-radio", {
                          staticClass: "radio-opts",
                          attrs: {
                            label:
                              "Delete Analytes that have no data associated with them during a rollback",
                            value: true,
                          },
                        }),
                        _vm._v(" "),
                        _c("v-radio", {
                          staticClass: "radio-opts",
                          attrs: {
                            label:
                              "Do not delete Analytes and mark the rollback as unsuccessful when attempting to delete an Analyte",
                            value: false,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      },
      "ColumnEditModal",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }